
define('template!companiesDetailBodySubaccountsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<table class="table table-hover subaccounts-table">\n  <thead>\n    <tr>\n      <th>' +
((__t = ( _.i18n('common.code') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.firstName') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.lastName') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.email') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.city') )) == null ? '' : __t) +
'</th>\n    </tr>\n  </thead>\n  <tbody class="subaccount-rows"></tbody>\n</table>\n';

}
return __p
};});

